/* eslint-disable camelcase */
import { useTranslation } from 'react-i18next';
import * as yup from 'yup';

export const useSchemaCreateSendInvite = () => {
  const { t } = useTranslation();

  const sendInviteCreateSchema = yup.object().shape({
    subject: yup
      .string()
      .required(t('event:validationMessage.fieldRquired'))
      .max(75, t('common:validationMessages.maxLength', { count: 75 })),
    body: yup.string().required(t('event:validationMessage.fieldRquired')),
    selection_id: yup.number(),
    selectionType: yup.number().optional(),
    speedFormText: yup.string().optional(),
    speedFormValues: yup.string().optional(),
    externalParticipants: yup.array().of(
      yup.lazy((value) => {
        const { email, firstname, lastname } = value;
        if (email === '' && firstname === '' && lastname === '') {
          return yup.object().shape({
            email: yup.string().email(t('event:validationMessage.validEmail')).default(''),
            firstname: yup.string().default(''),
            lastname: yup.string().default(''),
          });
        }
        return yup.object().shape({
          email: yup.string().email(t('event:validationMessage.validEmail')).required(t('event:validationMessage.fieldRquired')),
          firstname: yup.string().required(t('event:validationMessage.fieldRquired')),
          lastname: yup.string().required(t('event:validationMessage.fieldRquired')),
        });
      }),
    ),
    atLeastOneRequired: yup.lazy((_value, { parent }) => {
      const { selection_id, speedFormValues, externalParticipants } = parent;
      if (externalParticipants && externalParticipants.length > 0 && externalParticipants[0].email.length > 1) return yup.string();
      if (selection_id && selection_id !== 0) return yup.string();
      if (speedFormValues && speedFormValues.length > 0) return yup.string();
      return yup.string().required(t('event:validationMessage.atLeastOneRequired'));
    }),
    excludedMemberFromSelection: yup.array().of(
      yup.object().shape({
        member_id: yup.number().required(),
        firstName: yup.string(),
        lastName: yup.string(),
        email: yup.string(),
      }),
    ),
  });

  return sendInviteCreateSchema;
};
